"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = 'M10.5199 5.42385C10.8381 5.15868 11.311 5.20167 11.5762 5.51988L16.3094 11.1998C16.6957 11.6633 16.6957 12.3367 16.3094 12.8002L11.5762 18.4802C11.311 18.7984 10.8381 18.8414 10.5199 18.5762C10.2017 18.311 10.1587 17.8381 10.4238 17.5199L15.0237 12L10.4238 6.48016C10.1587 6.16195 10.2017 5.68903 10.5199 5.42385Z';